import EmtithalMasterTasks from './emtithalMasterTasksContainer';

export default EmtithalMasterTasks;
